module.exports = __webpack_public_path__ + "static/media/id_image_en@2x.8940ae14.png";